export type SelectedPlan = { plan: string; interval: 'month'|'year' }

const KEY = 'selected-plan'

export function setSelectedPlan(sel: SelectedPlan) {
  // Sempre preferir id se existir, para evitar ambiguidades de slug entre intervalos
  const planRef = sel.plan
  const safePlan = typeof planRef === 'string' ? planRef : String(planRef || '')
  try { sessionStorage.setItem(KEY, JSON.stringify({ plan: safePlan, interval: sel.interval })) } catch {}
}

export function getSelectedPlan(): SelectedPlan | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const obj = JSON.parse(raw)
    if (obj && typeof obj.plan === 'string') return { plan: obj.plan, interval: (obj.interval === 'year' ? 'year' : 'month') }
  } catch {}
  return null
}

